import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, Container } from '@mui/material';

import Dashboard from './pages/Dashboard';
import SocialMediaPage from './pages/SocialMediaPage';
import StoreTrackingPage from './pages/StoreTrackingPage';
import UnifiedAnalyticsPage from './pages/UnifiedAnalyticsPage';
import AppMetricDashboard from './pages/AppMetricDashboard';
import AdminPanelsPage from './pages/AdminPanelsPage';
import AppStoreSubscriptionsPage from './pages/AppStoreSubscriptionsPage';
import Navbar from './components/Navbar';
import theme from './theme';
import { EmptyState } from './components/ui';
import './App.css';

const ComingSoon = ({ title }) => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <EmptyState
      title={title}
      description="This page is coming soon. Stay tuned."
    />
  </Container>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
          <Navbar />
          <Box component="main" sx={{ pt: { xs: 1, md: 2 } }}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/social-media" element={<SocialMediaPage />} />
              <Route path="/store-tracking" element={<StoreTrackingPage />} />
              <Route path="/unified-analytics" element={<UnifiedAnalyticsPage />} />
              <Route path="/app-metrics" element={<AppMetricDashboard />} />
              <Route path="/app-store-subscriptions" element={<AppStoreSubscriptionsPage />} />
              <Route path="/admin-panels" element={<AdminPanelsPage />} />
              <Route path="/email-automation" element={<ComingSoon title="Email Automation" />} />
              <Route path="/analytics" element={<ComingSoon title="Analytics" />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
